import React from "react";
import TextField from "@mui/material/TextField";
import {
    FormControl,
    FormLabel,
    FormControlLabel,
    Radio,
} from "@mui/material";

interface FeedbackFormProps {
    state: {
        name: string;
        email: string;
        role: string;
        satisfaction: string;
        usefulness: string;
        speakerRating: string;
        likedMost: string;
        improvement: string;
    };
    handleFieldChange: (field: string, value: string) => void;
}

export const FeedbackForm: React.FC<FeedbackFormProps> = ({
    state,
    handleFieldChange,
}) => {
    const renderRadioGroup = (
        field: string,
        label: string,
        options: string[],
        columns: number = 5
    ) => {
        return (
            <FormControl component="fieldset">
                <FormLabel className="mb-2" focused={false}>
                    {label}
                </FormLabel>
                <div className="grid grid-col-5 gap-y-2 xl:grid-cols-5 xl:gap-x-4">
                    {options.map((option) => (
                        <FormControlLabel
                            key={option}
                            value={option}
                            control={
                                <Radio
                                    sx={{
                                        '&.Mui-checked': {
                                            color: "#D07D14",
                                        },
                                    }}
                                />
                            }
                            label={option}
                            className="items-center"
                            checked={state[field as keyof typeof state] === option}
                            onChange={(e) =>
                                handleFieldChange(field, (e.target as HTMLInputElement).value)
                            }
                            sx={{ color: "text.secondary" }}
                        />
                    ))}
                </div>
            </FormControl>
        );
    };

    return (
        <form className="checkout-form flex flex-col gap-6">
            <TextField
                label="Name*"
                value={state.name}
                onChange={(e) => handleFieldChange("name", e.target.value)}
                fullWidth
            />

            <TextField
                label="Email*"
                value={state.email}
                onChange={(e) => handleFieldChange("email", e.target.value)}
                fullWidth
            />

            {renderRadioGroup("role", "Were you attending as a*", ["Student", "Parent", "Other"])}

            {renderRadioGroup(
                "satisfaction",
                "How satisfied were you with the event overall?*",
                ["Very satisfied", "Satisfied", "Neutral", "Dissatisfied", "Very dissatisfied"]
            )}

            {renderRadioGroup(
                "usefulness",
                "How relevant or useful was the content to you?*",
                ["Extremely useful", "Somewhat", "Not very useful", "Not useful at all"]
            )}

            {renderRadioGroup(
                "speakerRating",
                "How would you rate the speakers/presenters?*",
                ["Excellent", "Good", "Fair", "Poor"]
            )}

            <TextField
                label="What did you like most about the event?"
                value={state.likedMost}
                onChange={(e) => handleFieldChange("likedMost", e.target.value)}
                multiline
                rows={3}
                fullWidth
            />

            <TextField
                label="What could we improve for next time?"
                value={state.improvement}
                onChange={(e) => handleFieldChange("improvement", e.target.value)}
                multiline
                rows={3}
                fullWidth
            />
        </form>
    );
};
